import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";
import axios from "axios";
import { BASE_URL } from "../../../Shared/URL.js";

export default function تحديث_الفئة() {
  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const navigate = useNavigate();
  const { CategoryId } = useParams();
  const API_BASE = `${BASE_URL}/Category`;

  async function getCategoryById(id) {
    try {
      const token = localStorage.getItem("__inventory_sys_auth_token_5f9dA72xQp__");
      if (!token) throw new Error("Token not found");

      let { data } = await axios.get(`${API_BASE}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data?.data || null;
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الفئة:", error);
      Swal.fire({
        title: "خطأ!",
        text: "فشل تحميل بيانات الفئة.",
        icon: "error",
      });
      navigate("/categories");
      return null;
    }
  }

  const formik = useFormik({
    initialValues: { id: "", name: "" },
    validate: (values) => {
      const errors = {};
      setErrorMsg(null);
      if (!values.name.trim()) errors.name = "اسم الفئة مطلوب";
      return errors;
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("__inventory_sys_auth_token_5f9dA72xQp__");
        if (!token) throw new Error("Token not found");

        const categoryData = { id: values.id, name: values.name.trim() };
        let { data } = await axios.put(`${API_BASE}/${CategoryId}`, categoryData, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (data?.status === 200) {
          await Swal.fire({
            title: "تم التحديث!",
            text: data.message || "تم تحديث الفئة بنجاح",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          navigate("/categories");
        }
      } catch (error) {
        console.error("حدث خطأ أثناء تحديث الفئة:", error);
        setErrorMsg(error?.response?.data?.message || "حدث خطأ ما");
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    async function loadData() {
      setIsLoadingData(true);
      const categoryData = await getCategoryById(CategoryId);
      if (categoryData) {
        formik.setValues({ id: categoryData.id, name: categoryData.name || "" });
      }
      setIsLoadingData(false);
    }
    if (CategoryId) loadData();
  }, [CategoryId]);

  if (isLoadingData) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          background: "#f0f4f8",
        }}
      >
        <Bars height="100" width="100" color="#0ea5e9" ariaLabel="loading" />
        <p style={{ marginTop: "20px", color: "#64748b", fontSize: "18px" }}>
          جارٍ تحميل بيانات الفئة...
        </p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8", paddingBottom: "40px", direction: "rtl" }}>
      <div className="container py-5 mt-5" style={{ maxWidth: "600px" }}>
        <div style={cardStyle} className="mt-5">
          <h2 style={headerStyle}>
            <i className="bi bi-folder2-open me-2"></i> تحديث القسم
          </h2>
          <p style={subHeaderStyle}>تعديل اسم الفئة الحالية</p>

          {errorMsg && <div style={errorBoxStyle}>{errorMsg}</div>}

          <form onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <label style={labelStyle}>اسم القسم  *</label>
              <input
                type="text"
                name="name"
                placeholder="أدخل اسم الفئة"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor: formik.touched.name && formik.errors.name ? "#dc2626" : "#cbd5e1",
                }}
              />
              {formik.errors.name && formik.touched.name && (
                <div style={errorTextStyle}>{formik.errors.name}</div>
              )}
            </div>

            <div className="d-flex gap-3">
              <button
                type="submit"
                disabled={!(formik.dirty && formik.isValid) || isLoading}
                style={{
                  ...buttonStyle,
                  background: formik.dirty && formik.isValid && !isLoading
                    ? "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)"
                    : "#94a3b8",
                  cursor: formik.dirty && formik.isValid && !isLoading ? "pointer" : "not-allowed",
                }}
              >
                {isLoading ? (
                  <Bars height="25" width="25" color="#fff" ariaLabel="loading" />
                ) : (
                  "تحديث الفئة"
                )}
              </button>

              <button
                type="button"
                onClick={() => navigate("/categories")}
                style={{
                  ...buttonStyle,
                  background: "#fff",
                  border: "2px solid #cbd5e1",
                  color: "#475569",
                }}
              >
                إلغاء
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Styles
const cardStyle = {
  background: "#fff",
  borderRadius: "12px",
  padding: "32px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
};

const headerStyle = {
  color: "#0ea5e9",
  fontSize: "26px",
  fontWeight: "700",
  marginBottom: "4px",
};

const subHeaderStyle = {
  color: "#64748b",
  fontSize: "14px",
  marginBottom: "20px",
};

const labelStyle = {
  fontWeight: "600",
  marginBottom: "6px",
  display: "block",
  color: "#334155",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "2px solid #cbd5e1",
  borderRadius: "8px",
  fontSize: "15px",
  outline: "none",
  transition: "all 0.2s",
};

const errorTextStyle = {
  color: "#dc2626",
  marginTop: "6px",
  fontSize: "13px",
  fontWeight: "600",
};

const errorBoxStyle = {
  background: "#fee2e2",
  border: "1px solid #fecaca",
  color: "#991b1b",
  padding: "12px 16px",
  borderRadius: "8px",
  marginBottom: "20px",
  fontSize: "14px",
  fontWeight: "600",
};

const buttonStyle = {
  flex: 1,
  padding: "14px",
  borderRadius: "8px",
  border: "none",
  fontWeight: "700",
  fontSize: "16px",
  color: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 0.3s ease",
};
